export { default } from "./withChallengesPrivileges";
